//////////////////////////////////////////////////////////////////////////
//
//  Copyright (C) 2007-2023 zSpace, Inc.  All Rights Reserved.
//
//////////////////////////////////////////////////////////////////////////

import * as THREE from 'three';
import { VRButton } from './VRButton';
import { ViewportController } from '../ViewportController';
import { StylusPointer } from '../StylusPointer';
import { ExitButton } from '../ExitButton';

var BaseDemo = function(){
  this.canvas = document.getElementById('main');
  this.clock = new THREE.Clock();
  this.scene = new THREE.Scene();
  this.scene.background = new THREE.Color( 0x808080 );
  this.camera = new THREE.PerspectiveCamera(
    50, window.innerWidth / window.innerHeight, 0.1, 10 );

  this.camera.near = 0.001;
  this.camera.far = 100000;

  this.renderer = new THREE.WebGLRenderer( { canvas: this.canvas, antialias: true } );
  this.renderer.setPixelRatio( window.devicePixelRatio );
  this.renderer.setSize( window.innerWidth, window.innerHeight );
  this.renderer.outputEncoding = THREE.sRGBEncoding;

  this.initViewController();
  this.scene.add(this.viewController);

  if(typeof navigator !== 'undefined' && 'xr' in navigator) {
    navigator.xr.isSessionSupported('immersive-vr').then((supported) => {
      if (supported) {
        this.renderer.xr.enabled = true;
        this.renderer.xr.setReferenceSpaceType('local');

        if(this.renderer.xr.isPresenting){
          this.zSpaceInit();
        } else {
          this.renderer.xr.addEventListener('sessionstart',
            ()=>{this.zSpaceInit();});

          this.vrButton = VRButton.createButton( this.renderer );
          document.body.appendChild(this.vrButton);
        }

        this.renderer.xr.addEventListener('sessionend',
          ()=>{
            this.onZSpaceEnd();
          });
      } else {
        this.fallbackInit();
      }
    }).catch(() => {
      this.fallbackInit();
    });
  } else {
    this.fallbackInit();
  }

  window.addEventListener('resize', ()=>{this.onWindowResize();} );

  this.renderer.setAnimationLoop(()=>{this.onFallbackUpdate();});
};

BaseDemo.prototype = {
  zSpaceInit: function(){
    if(this.stylusPointer == null){
      this.stylusPointer = new StylusPointer(
        this.viewController, this.renderer.xr);
    }

    this.stylusPointer.visible = true;

    if(this.exitButton == null){
      this.initExitButton();
    }

    this.exitButton.visible = true;

    this.renderer.setAnimationLoop(()=>{this.onUpdate();});
  },

  onExitButtonClick: function(){
    this.exitButton.visible = false;
    this.renderer.xr.getSession().end();
  },

  fallbackInit: function(){
    this.renderer.setAnimationLoop(()=>{this.onFallbackUpdate();});
  },

  onBeforeRender: function(){
    this.viewController.update();
    this.stylusPointer.update();
  },

  onRender: function(){
    this.renderer.render(this.scene, this.camera);
  },

  onUpdate: function() {
    this.onBeforeRender();
    this.onRender();
  },

  onZSpaceEnd: function(){

    this.exitButton.visible = false;

    //document.body.removeChild(this.canvas);
    //this.canvas = document.createElement('canvas');
    //this.canvas.id = 'main';
    //document.body.appendChild(this.canvas);

    this.stylusPointer.visible = false;

    //this.renderer = new THREE.WebGLRenderer( { canvas: this.canvas, antialias: true } );
    //this.renderer.setPixelRatio( window.devicePixelRatio );
    //this.renderer.setSize( window.innerWidth, window.innerHeight );
    //this.renderer.outputEncoding = THREE.sRGBEncoding;
    //this.renderer.xr.enabled = true;
    //this.renderer.xr.setReferenceSpaceType('local');

    //this.viewController.webXRManager = this.renderer.xr;

    //this.renderer.xr.addEventListener('sessionstart',
    //  ()=>{this.zSpaceInit();});

    //this.renderer.xr.addEventListener('sessionend',
    //  ()=>{this.onZSpaceEnd();});

    //document.body.removeChild(this.vrButton);
    //this.vrButton = VRButton.createButton( this.renderer );
    //document.body.appendChild(this.vrButton);

    this.fallbackInit();
    this.onFallbackUpdate();
  },

  onFallbackBeforeRender: function(){
    this.viewController.update();
  },

  onFallbackRender: function(){
    this.renderer.render(this.scene, this.camera);
  },

  onFallbackUpdate: function() {
    this.onFallbackBeforeRender();
    this.onFallbackRender();
  },

  onWindowResize: function(){
    if(this.renderer.xr.isPresenting){ return; }

    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize( window.innerWidth, window.innerHeight );
  

  },

  initViewController: function(){
    this.viewController = new ViewportController(
      this.camera, this.renderer.xr, {width:0.344, height:0.193});
  },

  initExitButton: function(){
    this.exitButton = new ExitButton();
    this.exitButton.addEventListener('click', this.onExitButtonClick.bind(this));
    this.viewController.add(this.exitButton);

    let width = this.viewController.width - 
      this.viewController.metersPerPixelWidth * 150;

    let height = this.viewController.height - 
      this.viewController.metersPerPixelHeight * 100;

    this.exitButton.position.set(width/2, -height/2, 0);

    this.exitButton.scale.setScalar(0.01);

    this.exitButton.addEventListener('meshesLoaded', ()=>{
      this.exitButton.traverse((obj)=>{
        if(obj.isMesh){
          this.stylusPointer.intersectables.push(obj);
        }
      });
    });
  }
};

export { BaseDemo };